import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import {environment} from '../../../environments/environment';
import { Constant } from '../constant';
import { tap } from 'rxjs/operators';
import { EventManagerService } from '../service/event-manager.service';
declare let $;
@Injectable({ providedIn: 'root' })
export class ExecuteBeforeRequestInterceptor implements HttpInterceptor {
  private readonly urlBackEnd: any;
  extra: any;
  quanlity: any = 0;
  Constant = Constant;
  singleAPIs: any;
  listNoRetryAPI: any = [];
  listNoLoadingAPI: any = [];
  isLoad: boolean = false;
  modalRef: any;
  retryCount = 3;
  retryWaitMilliSeconds = 5000;
  constructor(
    private eventManagerService: EventManagerService,
  ) {
    this.urlBackEnd = environment.urlBackEnd;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpResponse<any>> {
    this.singleAPIs = this.singleAPIs ||  JSON.parse(sessionStorage.getItem('singleAPIs')) || {};
    let splits = request.url.split('/');
    let api = '';
    splits.forEach((item, index) => {
        if (index > 2 && !parseInt(item)) {
            api += '/' + item;
        }
    })
    api = api.replace('/web', '');
    const requestId = Date.now();
    this.beforeRequest(api, request.method, requestId);
    if (!this.singleAPIs) {
      this.singleAPIs = JSON.parse(sessionStorage.getItem('singleAPIs'));
    }
    if (this.singleAPIs[api] === 0) {
      this.singleAPIs[api]++;
      this.updateCache(api, 1);
    } else if (this.singleAPIs[api] && this.singleAPIs[api] > 0) {
      this.hideSpinner(api, requestId);
      return of();
    }
    return next.handle(request)
      .pipe(
        tap(
          (res: HttpResponse<any>) => {
            const version = localStorage.getItem("version");
            this.extra = res.body ? res.body.extra : null;
            if (this.extra) {
              if (version && this.extra.clientVersion && this.extra.clientVersion != version) {
                  localStorage.setItem("version", this.extra.clientVersion);
                  // console.log('after version: ', version);
                  location.reload();
              } else  if (!version) {
                  localStorage.setItem("version", this.extra.clientVersion);
              }
           }
           if (res.status === 204) {
            this.hideSpinner(api, requestId);
            if (this.singleAPIs[api] !== undefined) {
              setTimeout(() => {
                this.updateCache(api, 0);
              }, 3000)
            }
           }
          },
          (err: any) => {
            this.hideSpinner(api, requestId);
            if (this.singleAPIs[api] !== undefined) {
              setTimeout(() => {
                this.updateCache(api, 0);
              }, 3000)
            }
            return err;
          },
          () => {
            this.hideSpinner(api, requestId);
            if (this.singleAPIs[api] !== undefined) {
              setTimeout(() => {
                this.updateCache(api, 0);
              }, 3000)
            }
          }
        ),
        // retryWhen(error => 
        //   error.pipe(
        //     concatMap((error, count) => {
        //       if (!this.checkExistNoRetryAPI(api) && count < this.retryCount && !error.status) {
        //         console.log('retry - api: ', count + '-' + api);
        //         this.eventManagerService.broadcast({
        //           name: 'show-spinner',
        //           content: {}
        //         })
        //         return of(error);
        //       } else {
        //         console.log('ignore retry - api: ', '-' + api);
        //       }
        //       return throwError(error);
        //     }),
        //     delay(this.retryWaitMilliSeconds)
        //   )
        // )
      )
  }
  checkExistNoLoadingAPI(api, method?) {
    this.listNoLoadingAPI = (this.listNoLoadingAPI.length  ?  this.listNoLoadingAPI :  JSON.parse(sessionStorage.getItem('noLoadingAPIs'))) || [];
    return this.listNoLoadingAPI.find((item: any) => { 
      return api.includes(item.url) && (!item.method || (item.method && item.method === method));
    })
  }
  checkExistShortLoadingAPI(api, method?) {
    this.listNoLoadingAPI = (this.listNoLoadingAPI.length  ?  this.listNoLoadingAPI :  JSON.parse(sessionStorage.getItem('shortLoadingAPIs'))) || [];
    return this.listNoLoadingAPI.some((item: any) => { 
      return api.includes(item.url) && (!item.method || (item.method && item.method === method));
    })
  }
  checkExistNoRetryAPI(api) {
    this.listNoRetryAPI = (this.listNoRetryAPI.length  ?  this.listNoRetryAPI :  JSON.parse(sessionStorage.getItem('noRetryAPIs'))) || [];
    return this.listNoRetryAPI.some((key) => { 
      return api.includes(key);
    })
  }
  updateCache(api, value) {
    this.singleAPIs[api] = value;
  }
  private beforeRequest(api, method, requestId?): void {
    const config = this.checkExistNoLoadingAPI(api, method);
    if (config) {
      if (!config.noProgress) {
        this.pushProgressList(api, requestId, true);
      }
      // console.log('no loading: ', api);
      return;
    }
    // console.log('add api: ', api);
    this.quanlity++;
    // show spinner
    setTimeout(() => {
      if (this.isLoad || !this.quanlity) {
        return;
      }
      this.isLoad = true;
      // console.log('loading API: ', api);
      this.eventManagerService.broadcast({
        name: 'show-spinner',
        content: {}
      })
    }, 3000)
    if (this.checkExistShortLoadingAPI(api, method)) {
      // console.log('short loading: ', api);
      setTimeout(() => {
        if (this.isLoad) {
          this.hideSpinner(api, requestId);
          this.pushProgressList(api, requestId, true);
        }
      }, 1000 * 10)
      return;
    }
    // hide spinner
    setTimeout(() => {
      if (this.isLoad) {
        this.hideSpinner(api, requestId);
        this.pushProgressList(api, requestId, true);
      }
    }, 1000 * 60 * 2)
  }
  hideSpinner(api, requestId) {
    if (this.quanlity > 0) {
      this.quanlity--;
    }
    setTimeout(() => {
      this.pushProgressList(api, requestId, false);  
    }, 500)
    // close spinner
    if (this.quanlity == 0) {
      this.isLoad = false;
      this.eventManagerService.broadcast({
        name: 'close-spinner',
        content: {}
      });
    }
  }
  pushProgressList(api, requestId, isLoad?) {
    this.eventManagerService.broadcast({
      name: 'waiting-request',
      content: {
        request: api,
        requestId,
        isLoad: isLoad
      }
    })
  }
}
